export enum ENUM_DEAL_STATUS {
  All = 'All',
  Expired = 'Expired',
  Active = 'Active',
  Upcoming = 'Upcoming'
}

export enum ENUM_EXPLORE_CARD_STATUS {
  PROMO = 'Promo'
}
export enum ENUM_HOME_FILTERS {
  ALL = 'All',
  ACTIVE = 'Active post',
  INACTIVE = 'Inactive post'
}

export enum ENUM_POST_TYPES {
  FCB = 'fcb',
  FC = 'fc',
  BUDGET = 'budget',
  SHOP = 'shop'
}

export enum ENUM_PERFORMANCE_FILTERS {
  TOTAL = 'total',
  HIGH = 'high',
  LOW = 'low',
  AVG = 'average'
}

export enum ENUM_DEAL_VALUE_TYPES {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT'
}

export enum ENUM_DEAL_TYPES {
  ALL = 'ALL',
  BRAND = 'BRAND',
  MEAL = 'MEAL'
}

export enum ENUM_DEAL_REQUIREMENT_TYPES {
  NONE = 'NONE',
  MINIMUM_PURCHASE_AMOUNT = 'MINIMUM_PURCHASE_AMOUNT',
  MINIMUM_QUANTITY_OF_ITEMS = 'MINIMUM_QUANTITY_OF_ITEMS'
}

export enum ENUM_DEAL_ELIGIBILITY_TYPES {
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS'
}

export enum ENUM_AM_PM {
  AM = 'AM',
  PM = 'PM'
}

export enum ENUM_DISPLAY_MODE {
  CTA = 'cta',
  MEAL_CARD = 'meal card'
}
